<template>
    <div>
        <h1 style="text-align: center;">Biography Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntImg">
                <h2>Image</h2>
                <div><img :src="img.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="imgsel" v-on:change="changeImage()" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
          
            <div ref="cntDesc">
                <h2>Description</h2>
                <quill-editor v-model="desc">
                </quill-editor>
            </div>
            <div>
                <button @click="submitThis()" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Please fix the error";
        color: red;
        background: white;
        font-weight: 800;
    }
    h2{
      color: black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
</style>

<script>
import {Functions} from './functions.js';

export default {
    name: "BiographyAddEditComponent",
    props: ['imageId'],
    data: () => ({
        isLoading: true,
        title: "",
        desc: "",
        id: undefined,
        img: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined
    }),
    mounted: function() {
        this.functions = new Functions();
        if(this.imageId){
            //Edit
            this.functions.getComponent(this.imageId, (data) => {
                console.log(data);
                this.title = data.title;
                this.desc = data.data.imgdesc;
                // this.$refs.quillEditor.quill.setContents(this.desc);
                this.id = data.contentId;
                this.img.publicUrl = data.data.imgsrc;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.img.data = data.data.imgsrc;
                console.log(1);
                this.functions.getSignedUrl("ttedu-public-uploads", this.img.publicUrl.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg", "putObject", (dat) => {
                    console.log(2, data.rdsDat[0].Thumbnail);
                    this.img.uploadUrl = dat.signedUrl;
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg", "getObject", (thumbBuff) => {
                        console.log(3, thumbBuff);
                        this.thumbnail.data = thumbBuff.signedUrl;
                        this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg", "putObject", (thumbBuff1) => {
                            console.log(4);
                            this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                            this.isLoading = false;
                        });
                    });
                });
            });
        }else{
            //Create New
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.functions.getImageURL((dat) => {
                    this.img.publicUrl = dat.key;
                    this.img.uploadUrl = dat.signedUrl;
                    this.isLoading = false;
                }, err => console.error(err));
            },(err) => {
                console.error(err);
            });
        }
    },
    methods: {
        changeImage: function(){
            var reader = new FileReader();
            reader.onload = (e) => {
                this.img.data = e.target.result;
                this.thumbnail.data = e.target.result;
            }
            reader.readAsDataURL(this.$refs.imgsel.files[0]);
            this.img.file = this.$refs.imgsel.files[0];
            this.thumbnail.file = this.$refs.imgsel.files[0];
        },
        onEditorChange(e){
            this.desc = e.html.replace(/p>/g, "div>");
        },
        updateThis(){
            console.log("UPDATING");
            this.$refs.cntTitle.classList.remove("has-error");
            this.$refs.cntDesc.classList.remove("has-error");
            this.$refs.cntImg.classList.remove("has-error");
            let hasError = false;
            if(this.title.trim() == ""){
                this.$refs.cntTitle.classList.add("has-error");
                hasError = true;
            }
            if(this.desc.trim() == ""){
                this.$refs.cntDesc.classList.add("has-error");
                hasError = true;
            }
            // if(this.img.file == undefined){
            //     this.$refs.cntImg.classList.add("has-error");
            //     hasError = true;
            // }
            if(hasError){
                console.log("HAS ERROR");
                return false;
            }
            this.isLoading = true;
            var componentData = {
                ContentType: "INTERACTIVE",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: "biography",
                Data: {
                    imgtitle: this.title,
                    imgsrc: this.img.publicUrl,
                    imgdesc: this.desc
                }
            };

            if(this.img.file != undefined){
                this.functions.upload(this.img.uploadUrl, this.img.file, (data) => {
                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                        this.functions.updateComponent(this.id, componentData,(dat) => {
                            console.log(dat);
                            this.$router.push("/editors/component/biography");
                        });
                    });
                });
            }else{
                this.functions.updateComponent(this.id, componentData,(dat) => {
                    console.log(dat);
                    this.$router.push("/editors/component/biography");
                });
            }
        },
        submitThis(){
            if(this.id){
                this.updateThis();
                return null;
            }
            this.$refs.cntTitle.classList.remove("has-error");
            this.$refs.cntDesc.classList.remove("has-error");
            this.$refs.cntImg.classList.remove("has-error");
            let hasError = false;
            if(this.title.trim() == ""){
                this.$refs.cntTitle.classList.add("has-error");
                hasError = true;
            }
            if(this.desc.trim() == ""){
                this.$refs.cntDesc.classList.add("has-error");
                hasError = true;
            }
            if(this.img.data == ""){
                this.$refs.cntImg.classList.add("has-error");
                hasError = true;
            }
            if(hasError){
                console.log("HAS ERROR");
                return false;
            }
            this.isLoading = true;
            var componentData = {
                ContentType: "INTERACTIVE",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: "biography",
                Data: {
                    imgtitle: this.title,
                    imgsrc: this.img.publicUrl,
                    imgdesc: this.desc
                }
            };
            // console.log(componentData);

            this.functions.upload(this.img.uploadUrl, this.img.file, (data) => {
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.functions.addComponent(componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/biography");
                    });
                });
            });
        }
    }
}
</script>